/**
 * Required default variables.
 *
 * CenterX
 * CenterY
 * Width
 * Height
 * RepeatNumber
 * Pi?
 */

const app = {

	/**
	 * HTML elements.
	 */
	$canvas: null,
	$cursor: null,
	$code: null,

	/**
	 * The Turtle.
	 * @type {Turtle}
	 */
	turtle: null,

	runner: null,

	/**
	 * The current size of the canvas.
	 *
	 * @type {string}
	 */
	currentSize: 'square',

	codeEditor: null,

	parser: null,

	/**
	 * The default code to start with.
	 */
	codeStart: `
setw 4
repeat 4 {
	colorrand
	fd 100
	rt 90
}
		`,

	// 	codeStart: `
	// repeat 20 {
	// 	colorrand
	// 	var side rand 200
	// 	repeat 4 {
	// 		fd $side
	// 		rt 90
	// 	}
	// 	rt rand 360
	// }`,

	/**
	 * Init the app.
	 *
	 * @return {void}
	 */
	init: function() {

		document.addEventListener( 'login-status-change', app.loginStatusChange );

		// Get items.
		app.$canvas = document.getElementById( 'code-drawing' );
		app.$cursor = document.getElementById( 'code-cursor' );

		// Create the Turtle.
		app.turtle = new Turtle( app.$canvas.getContext( '2d' ), app.$cursor.getContext( '2d' ) );

		// Update the highlighting keywords.
		// codeHighlighting.keywords = [ ...Object.keys( commandList ), ...Object.keys( keywordList ) ];
		app.keywordList = [ ...Object.keys( commandList ), ...Object.keys( keywordList ) ];

		// Setup the code editor.
		// app.codeEditor = new CodeEditor( document.querySelector( '#logo-text' ) );
		// app.codeEditor.setHighlighter( codeHighlighting.highlight );
		// app.codeEditor.value = app.codeStart.trim();
		// app.codeEditor.create();

		app.codeEditor = initEditor( 'logo-text' );
		app.setCode( app.codeStart.trim() );

		// Run button.
		const runButton = document.getElementById( 'run' );
		runButton.addEventListener(
			'click',
			app.draw
		);

		// Shortcut key.
		Mousetrap.bind(
			'alt+r',
			app.draw
		);

		app.draw();

		// New code example loaded.
		document.addEventListener(
			'load-code-loaded',
			app.draw
		);

		// Save the output as an image.
		document.getElementById( 'download-image' ).addEventListener(
			'click',
			app.savePng
		);

		// Change canvas size.
		// document.getElementById( 'settings-image-size' ).addEventListener(
		// 	'click',
		// 	app.setSize
		// );

		document.getElementById( 'load-examples' ).addEventListener(
			'click',
			app.loadExamples
		);

		document.getElementById( 'clear-code' ).addEventListener(
			'click',
			( e ) => {
				e.preventDefault();
				app.setCode( '' );
			}
		);

		document.getElementById( 'save-code' ).addEventListener(
			'click',
			( e ) => {
				e.preventDefault();
				downloadTextFile( 'code-ninja.codeninja', app.codeEditor.getValue() );

				shareModal.show(
					'Code Saved',
					'Your code has been saved. You will find it in your Downloads folder!'
				);

			}
		);

	},


	/**
	 * Display Code Ninja for subscribers, and keep it hidden for everyone else.
	 *
	 * @return {void}
	 */
	loginStatusChange: function() {

		if ( members.isSubscriber() ) {

			const $wrappers = document.querySelectorAll( '.brush-ninja-code-ninja' );

			$wrappers.forEach(
				( $elem ) => {
					$elem.style.display = 'block';
				}
			);

			app.codeEditor.update();

			return;

		}

	},


	/**
	 * Run the code.
	 *
	 * @return {void}
	 */
	draw: function() {

		app.turtle.reset();

		// Generate an object with all of the commands and their properties.
		app.parser = new Parser( app.codeEditor.getValue() );

		// Stop existing runner.
		if ( app.runner ) {
			app.runner.stop();
		}

		// Run the commands.
		app.runner = new Runner( app.turtle, app.parser.tokens, app.parser.functions );
		app.runner.start();

	},


	/**
	 * Update the editor code.
	 *
	 * @param {string} newCode The new code.
	 * @return {void}
	 */
	setCode: function( newCode ) {

		app.codeEditor.setValue( newCode.trim() );

	},


	/**
	 * Update the dimensions of the canvas.
	 *
	 * @return {void}
	 */
	// setSize: function() {

	// 	app.currentSize++;
	// 	if ( app.currentSize >)

	// },


	/**
	 * Save an image of the rendered content.
	 *
	 * @return {void}
	 */
	savePng: function() {

		const $wrapper = document.getElementById( 'code-wrapper' );
		$wrapper.classList.add( 'render' );

		/**
		 * Set the scale to 1 so that we don't get blurring.
		 *
		 * Probably don't need the Math.min but keeping it in case I change the
		 * scale for some reason.
		 */
		const canvasScale = Math.min( window.devicePixelRatio, 1 );

		html2canvas(
			$wrapper,
			{
				backgroundColor: null,
				scale: canvasScale,
			}
		).then(
			( canvas ) => {

				const src = canvas.toDataURL( 'image/png' );

				downloadLink( 'code-ninja.png', src );

				$wrapper.classList.remove( 'render' );

				shareModal.show(
					'Image Saved',
					'Your Code Ninja image has been saved. You will find it in your Downloads folder!'
				);

			}
		);

	},


	/**
	 * Load a list of example code.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	loadExamples: function( e ) {

		e.preventDefault();

		loadCode.items = code_2d_examples;
		loadCode.setCode = app.setCode;
		loadCode.assetPrefix = '2d';

		loadCode.show();

	},

};



(
	function() {

		'use strict';

		ready(
			function() {

				app.init();

			}
		);

	}
)();
